/**
 * Created by coolguy on 2017/7/3.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('area');
const AREA_LIST = "AREA_LIST";
const AREA_ADD = "AREA_ADD";
const AREA_DELETE = "AREA_DELETE";
const AREA_EDIT = "AREA_EDIT";
const AREA_DETAIL = "AREA_DETAIL";

export default {
    AREA_LIST,
    areaList : ()=>{
        return ajaxCommon({
            api:TheApi('get')(),
            success: (data)=>({
                type:AREA_LIST,
                data
            })
        })
    },
    AREA_ADD,
    areaAdd : (params)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:AREA_ADD,
                data
            })
        })
    },
    AREA_DELETE,
    areaDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:AREA_DELETE,
                data,
            })
        })
    },
    AREA_EDIT,
    areaEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:AREA_EDIT,
                data,
            })
        })
    },
    AREA_DETAIL,
    areaDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')(id),
            success:(data)=>({
                type:AREA_DETAIL,
                data,
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/actions/AreaAction.js